export default __webpack_public_path__ + "static/media/followus.55fc08d3.svg";